<template>
  <div class="agency">
    <div class="container-fluid py-4">
      <h2 class="h4 fw-medium mb-4">{{ $t("__agencyManagement") }}</h2>
      <div
        class="d-flex align-items-center justify-content-between mb-3 flex-wrap"
      >
        <div class="d-flex align-items-center me-2 mb-2" v-if="isSystemManage">
          <div class="device-report-select">
            <select v-model="searchAgent" class="form-select rounded-pill me-2">
              <option :value="null">{{ $t("__all") + $t("__agent") }}</option>
              <option
                v-for="item in agents"
                :value="item.id"
                :key="'agent' + item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <form @submit.prevent="searchAgency" class="me-2 mb-2">
          <div class="input-group rounded-pill">
            <input
              v-model="search"
              type="text"
              class="form-control rounded-pill"
              :placeholder="$t('__searchAgencyName')"
              aria-label="search"
              aria-describedby="search"
            />
            <button
              type="submit"
              class="btn btn-link px-2 text-dark"
              id="search"
            >
              <i class="bi bi-search"></i>
            </button>
            <button
              v-if="filter"
              type="button"
              class="btn btn-primary px-3 ms-1 rounded-pill"
              id="clearSearch"
              @click="clearSearch"
            >
              {{ $t("__clearSearch") }}
            </button>
          </div>
        </form>
        <form @submit.prevent="searchAgencyByName" class="me-auto me-2 mb-2">
          <div class="input-group rounded-pill">
            <input
              v-model="searchAgentCode"
              type="text"
              class="form-control rounded-pill"
              :placeholder="$t('__searchAgencyCode')"
              aria-label="search"
              aria-describedby="search"
            />
            <button
              type="submit"
              class="btn btn-link px-2 text-dark"
              id="search"
            >
              <i class="bi bi-search"></i>
            </button>
            <button
              v-if="filter"
              type="button"
              class="btn btn-primary px-3 ms-1 rounded-pill"
              id="clearSearch"
              @click="clearSearch"
            >
              {{ $t("__clearSearch") }}
            </button>
          </div>
        </form>
        <button
          v-if="$store.getters.hasPermission('agency.create')"
          @click="showModal()"
          class="mb-2 fs-5 btn btn-primary px-2 rounded-circle lh-sm"
        >
          <i class="bi bi-plus"></i>
        </button>
      </div>
      <div class="card">
        <div v-if="items" class="card-body">
          <b-table
            :responsive="$store.state.windowWidth > $store.state.breakpoints.sm"
            :stacked="$store.state.windowWidth <= $store.state.breakpoints.sm"
            striped
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(locale)="data">
              {{ $t("__" + data.item.locale) }}
            </template>
            <template v-slot:cell(api)="data">
              {{ data.item.api ? apiPlatforms[data.item.api] : "" }}
            </template>
            <template v-slot:cell(status)="data">
              <div
                class="status-switch"
              >
                <input
                  type="checkbox"
                  :id="'switch-' + data.index"
                  v-model="data.item.status"
                  @click="changeStatusAlert(data.item.id)"
                  :disabled="!$store.getters.hasPermission('agency.update')"
                />
                <label :for="'switch-' + data.index"></label>
              </div>
            </template>
            <template v-slot:cell(manager_id)="data">
              <div
                v-if="isSystemManage && data.item.manager_id !== userInfo.id"
              >
                {{
                  data.item.manager_id
                    ? data.item.manager.name +
                      " / " +
                      data.item.manager.username
                    : "Humetrics / Admin"
                }}
              </div>
            </template>
            <template v-slot:cell(active)="data">
              <div
                class="d-flex"
              >
                <button
                  @click="$store.getters.hasPermission('agency.update') && showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  :class="$store.getters.hasPermission('agency.update') ? 'text-dark' : 'text-muted'"
                  :disabled="!$store.getters.hasPermission('agency.update')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$store.getters.hasPermission('agency.update') ? $t('__edit') : $t('__noPermission')"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <button
                  @click="$store.getters.hasPermission('agency.update') && showFeatureModal(data.item)"
                  type="button"
                  class="btn btn-link px-1"
                  :class="$store.getters.hasPermission('agency.update') ? 'text-dark' : 'text-muted'"
                  :disabled="!$store.getters.hasPermission('agency.update')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$store.getters.hasPermission('agency.update') ? $t('__featureSettings') : $t('__noPermission')"
                >
                  <i class="bi bi-gear mx-1 fs-5"></i>
                </button>
                <button
                  @click="$store.getters.hasPermission('agency.update') && showApiTokenModal(data.item)"
                  type="button"
                  class="btn btn-link px-1"
                  :class="$store.getters.hasPermission('agency.update') ? 'text-dark' : 'text-muted'"
                  :disabled="!$store.getters.hasPermission('agency.update')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$store.getters.hasPermission('agency.update') ? $t('__apiTokenManagement') : $t('__noPermission')"
                >
                  <i class="bi bi-key mx-1 fs-5"></i>
                </button>
                <button
                  v-if="data.item.status && $store.getters.hasPermission('agency.impersonate')"
                  type="button"
                  class="btn btn-link px-1 text-primary"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$t('__loginAsUser')"
                  @click="impersonate(data.item.id)"
                >
                  <i class="bi bi-box-arrow-in-right mx-1 fs-5"></i>
                </button>
                <button
                  v-if="!data.item.status && !data.item.devices_count && $store.getters.hasPermission('agency.delete')"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="$t('__delete')"
                  @click="deleteAgencyAlert(data.item.id)"
                >
                  <i class="bi bi-trash fs-5"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row align-items-center mt-3" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          {{
            $t("__paginationInfo", {
              startNub: currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1,
              entNub:
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage,
              sum: totalRows,
            })
          }}
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3"
          ></b-pagination>
        </div>
      </div>
    </div>
    <div class="modal fade cms-style" tabindex="-1" id="edit" ref="editModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="submitForm">
            <div class="modal-header">
              <h5 class="modal-title fw-medium">
                {{ isEdit ? $t("__editAgency") : $t("__addAgency") }}
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="codename" class="form-label fw-medium required">{{
                  $t("__agencyCodename")
                }}</label>
                <input
                  v-model="modalData.codename"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': validate && validate.msg.codename,
                  }"
                  id="codename"
                  required
                  :readonly="isEdit"
                />
                <div
                  class="invalid-feedback"
                  v-if="validate && validate.msg.codename"
                >
                  <div
                    v-for="(msg, index) in validate.msg.codename"
                    :key="index"
                  >
                    {{ msg }}
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="name" class="form-label fw-medium required">{{
                  $t("__agencyName")
                }}</label>
                <input
                  v-model="modalData.name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': validate && validate.msg.name,
                  }"
                  id="name"
                  required
                />
                <div
                  class="invalid-feedback"
                  v-if="validate && validate.msg.name"
                >
                  <div v-for="(msg, index) in validate.msg.name" :key="index">
                    {{ msg }}
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="name" class="form-label fw-medium required">{{
                  $t("__language")
                }}</label>
                <select class="form-select" v-model="modalData.locale">
                  <option :value="null">
                    {{ $t("__openThisSelectMenu") }}
                  </option>
                  <option
                    v-for="item in language"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="api_platform" class="form-label fw-medium">{{
                  $t("__apiPlatform")
                }}</label>
                <select class="form-select" v-model="modalData.api">
                  <option :value="null">
                    {{ $t("__openThisSelectMenu") }}
                  </option>
                  <option
                    v-for="(name, value) in apiPlatforms"
                    :key="value"
                    :value="value"
                  >
                    {{ name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label fw-medium required">{{
                  $t("__agencyType")
                }}</label>
                <div class="d-flex">
                  <div class="form-check me-4">
                    <input
                      v-model="modalData.service_type"
                      class="form-check-input"
                      type="radio"
                      name="agency_service_type"
                      value="standard"
                      id="agency-service-type-standard"
                    />
                    <label
                      class="form-check-label fw-medium"
                      for="agency-service-type-standard"
                      >{{ $t("__agencyTypeStandard") }}</label
                    >
                  </div>
                  <div class="form-check">
                    <input
                      v-model="modalData.service_type"
                      class="form-check-input"
                      type="radio"
                      name="agency_service_type"
                      value="home_care"
                      id="agency-service-type-home-care"
                    />
                    <label
                      class="form-check-label fw-medium"
                      for="agency-service-type-home-care"
                      >{{ $t("__agencyTypeHomeCare") }}</label
                    >
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-medium required">{{
                  $t("__timezone")
                }}</label>
                <v-select
                  :placeholder="
                    $t('__openThisSelectMenu') + ' ( ' + $t('__search') + ' )'
                  "
                  v-model="modalData.timezone"
                  label="name"
                  :options="timezones"
                  :reduce="(timezone) => timezone.name"
                >
                  <template v-slot:option="option">
                    {{ option.name + " ： " + option.utc }}
                  </template>
                </v-select>
              </div>
              <div class="mb-3">
                <label class="form-label fw-medium">{{ $t("__agencyPdcaMonthlyQuota") }}</label>
                <input
                  v-model.number="modalData.pdca_monthly_quota"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                />
                <small class="text-muted">
                  {{ $t("__agencyQuotaUsageFormat", {
                    used: (modalData.pdca_used_this_month !== null && modalData.pdca_used_this_month !== undefined) ? modalData.pdca_used_this_month : 0,
                    total: (modalData.pdca_monthly_quota !== null && modalData.pdca_monthly_quota !== undefined) ? modalData.pdca_monthly_quota : 5
                  }) }}
                </small>
                <button
                  v-if="isEdit"
                  type="button"
                  class="btn btn-sm btn-outline-warning mt-2"
                  @click="showAdjustQuotaModal('pdca')"
                >
                  <i class="bi bi-sliders"></i> {{ $t("__adjustUsedQuota") }}
                </button>
              </div>
              <div class="mb-3">
                <label class="form-label fw-medium">{{ $t("__agencyCaseReportMonthlyQuota") }}</label>
                <input
                  v-model.number="modalData.case_report_monthly_quota"
                  type="number"
                  class="form-control"
                  min="0"
                  max="100"
                />
                <small class="text-muted">
                  {{ $t("__agencyQuotaUsageFormat", {
                    used: (modalData.case_report_used_this_month !== null && modalData.case_report_used_this_month !== undefined) ? modalData.case_report_used_this_month : 0,
                    total: (modalData.case_report_monthly_quota !== null && modalData.case_report_monthly_quota !== undefined) ? modalData.case_report_monthly_quota : 5
                  }) }}
                </small>
                <button
                  v-if="isEdit"
                  type="button"
                  class="btn btn-sm btn-outline-warning mt-2"
                  @click="showAdjustQuotaModal('case_report')"
                >
                  <i class="bi bi-sliders"></i> {{ $t("__adjustUsedQuota") }}
                </button>
              </div>
              <div v-if="modalData.quota_reset_at" class="mb-3">
                <small class="text-muted">
                  {{ $t("__agencyQuotaResetDate") }}{{ modalData.quota_reset_at }}
                </small>
              </div>
              <div class="mb-3">
                <label class="form-label fw-medium">{{ $t("__disconnectThresholdHours") }}</label>
                <div class="input-group">
                  <input
                    v-model.number="modalData.disconnect_threshold_hours"
                    type="number"
                    class="form-control"
                    min="1"
                    max="24"
                  />
                  <span class="input-group-text">{{ $t("__hours") }}</span>
                </div>
                <small class="text-muted">
                  {{ $t("__disconnectThresholdHoursHint") }}
                </small>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                class="btn btn-outline-secondary rounded-pill"
                data-bs-dismiss="modal"
              >
                {{ $t("__cancel") }}
              </button>
              <button type="submit" class="btn btn-primary rounded-pill">
                {{ $t("__save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="changeStatusModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="changeStatusModal"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__changeStatus") }}</h5>
          </div>
          <div class="modal-body text-center">
            <p class="mb-0">
              {{ $t("__changeStatusNote", { Agency: modalData.name }) }}
            </p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="changeStatus"
              type="button"
              class="btn btn-primary rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="deleteModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="deleteModal"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__deleteAgency") }}</h5>
          </div>
          <div class="modal-body text-center">
            <p class="mb-0">
              {{ $t("__deleteAgencyNote", { Agency: modalData.name }) }}
            </p>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="deleteAgency"
              type="button"
              class="btn btn-primary rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="adjustQuotaModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="adjustQuotaModal"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title">{{ $t("__adjustUsedQuota") }}</h5>
          </div>
          <div class="modal-body">
            <p class="mb-2">
              <strong>{{ $t("__agency") }}：</strong>{{ modalData.name }}
            </p>
            <p class="mb-2">
              <strong>{{ $t("__quotaType") }}：</strong>
              <template v-if="adjustQuotaType === 'pdca'">
                {{ $t("__agencyPdcaMonthlyQuota") }}
              </template>
              <template v-else>
                {{ $t("__agencyCaseReportMonthlyQuota") }}
              </template>
            </p>
            <p class="mb-3">
              <strong>{{ $t("__currentUsed") }}：</strong>
              <template v-if="adjustQuotaType === 'pdca'">
                {{ (modalData.pdca_used_this_month !== null && modalData.pdca_used_this_month !== undefined) ? modalData.pdca_used_this_month : 0 }}
                /
                {{ (modalData.pdca_monthly_quota !== null && modalData.pdca_monthly_quota !== undefined) ? modalData.pdca_monthly_quota : 5 }}
              </template>
              <template v-else>
                {{ (modalData.case_report_used_this_month !== null && modalData.case_report_used_this_month !== undefined) ? modalData.case_report_used_this_month : 0 }}
                /
                {{ (modalData.case_report_monthly_quota !== null && modalData.case_report_monthly_quota !== undefined) ? modalData.case_report_monthly_quota : 5 }}
              </template>
            </p>

            <div class="mb-3">
              <label class="form-label fw-medium">{{ $t("__newUsedValue") }}</label>
              <input
                v-model.number="adjustQuotaValue"
                type="number"
                class="form-control"
                :min="0"
                :max="adjustQuotaType === 'pdca' ? modalData.pdca_monthly_quota : modalData.case_report_monthly_quota"
              />
            </div>

            <div class="alert alert-warning mb-0">
              <i class="bi bi-exclamation-triangle-fill"></i>
              {{ $t("__adjustQuotaWarning") }}
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="confirmAdjustQuota"
              type="button"
              class="btn btn-warning rounded-pill"
            >
              {{ $t("__confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade cms-style"
      id="featureSettingsModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="featureSettingsModal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-medium">
              {{ featureModalAgency ? featureModalAgency.name : '' }} - {{ $t("__featureSettings") }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="featuresLoading" class="text-center py-3">
              <span class="spinner-border spinner-border-sm me-2"></span>
              {{ $t("__loading") }}...
            </div>
            <div v-else-if="agencyFeatures && agencyFeatures.length">
              <div
                v-for="feature in agencyFeatures"
                :key="feature.code"
                class="form-check mb-3"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :id="'feature-modal-' + feature.code"
                  v-model="feature.enabled"
                />
                <label
                  class="form-check-label"
                  :for="'feature-modal-' + feature.code"
                >
                  {{ feature.name }}
                  <small class="text-muted d-block">{{ feature.description }}</small>
                </label>
              </div>
            </div>
            <div v-else class="text-muted text-center py-3">
              {{ $t("__noFeaturesAvailable") }}
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__cancel") }}
            </button>
            <button
              @click="saveAgencyFeatures"
              type="button"
              class="btn btn-primary rounded-pill"
              :disabled="featuresLoading || !$store.getters.hasPermission('agency.update')"
            >
              {{ $t("__save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade cms-style"
      id="apiTokenModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      ref="apiTokenModal"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-medium">
              {{ apiTokenModalAgency ? apiTokenModalAgency.name : '' }} - {{ $t("__apiTokenManagement") }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="apiTokenPlainText" class="alert alert-warning">
              <div class="fw-medium mb-2">
                <i class="bi bi-exclamation-triangle-fill"></i>
                {{ $t("__apiTokenPlainTextWarning") }}
              </div>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control font-monospace"
                  :value="apiTokenPlainText"
                  readonly
                />
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="copyApiToken"
                >
                  <i class="bi bi-clipboard"></i> {{ $t("__apiTokenCopy") }}
                </button>
              </div>
            </div>
            <div class="row g-2 align-items-end mb-3">
              <div class="col-sm-8">
                <label for="apiTokenName" class="form-label fw-medium">{{
                  $t("__apiTokenName")
                }}</label>
                <input
                  v-model="apiTokenName"
                  type="text"
                  class="form-control"
                  id="apiTokenName"
                  :placeholder="$t('__apiTokenNamePlaceholder')"
                />
              </div>
              <div class="col-sm-4">
                <button
                  type="button"
                  class="btn btn-primary w-100"
                  :disabled="apiTokenLoading"
                  @click="createApiToken"
                >
                  <i class="bi bi-plus-lg"></i> {{ $t("__apiTokenGenerate") }}
                </button>
              </div>
            </div>
            <div v-if="apiTokenLoading" class="text-center py-3">
              <span class="spinner-border spinner-border-sm me-2"></span>
              {{ $t("__loading") }}
            </div>
            <div v-else-if="apiTokens.length" class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>{{ $t("__apiTokenName") }}</th>
                    <th>{{ $t("__createdAt") }}</th>
                    <th>{{ $t("__apiTokenLastUsedAt") }}</th>
                    <th class="text-end">{{ $t("__active") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in apiTokens" :key="'apiToken' + item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.created_at }}</td>
                    <td>
                      <span v-if="item.last_used_at">{{ item.last_used_at }}</span>
                      <span v-else class="text-muted">{{
                        $t("__apiTokenNeverUsed")
                      }}</span>
                    </td>
                    <td class="text-end">
                      <button
                        type="button"
                        class="btn btn-link px-1 text-danger"
                        :disabled="apiTokenLoading"
                        @click="revokeApiToken(item)"
                      >
                        {{ $t("__apiTokenRevoke") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-muted text-center py-3">
              {{ $t("__apiTokenEmpty") }}
            </div>
          </div>
          <div class="modal-footer justify-content-end">
            <button
              type="button"
              class="btn btn-outline-secondary rounded-pill"
              data-bs-dismiss="modal"
            >
              {{ $t("__close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip, Modal } from "bootstrap";
import i18n from "@/lang/lang.js";
import { agency } from "@/http/api/agency.js";
import { agent } from "@/http/api/agent.js";
import { mapState, mapMutations } from "vuex";
import moment from "moment-timezone";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "Agency",
  components: { vSelect },
  data() {
    return {
      agents: null,
      agency: null,
      filter: null,
      filterOn: ["name"],
      search: null,
      searchAgent: null,
      searchAgentCode: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      bootstrap_tooltip: null,
      bootstrap_modal: null,
      isEdit: false,
      editModalId: null,
      modalData: {
        name: null,
        codename: null,
        status: null,
        locale: null,
        timezone: null,
        api: null,
        service_type: "standard",
        pdca_monthly_quota: 5,
        case_report_monthly_quota: 5,
        pdca_used_this_month: 0,
        case_report_used_this_month: 0,
        quota_reset_at: null,
        disconnect_threshold_hours: 3,
      },
      validate: null,
      // 由 GET /api/agency/api-platforms 載入（引 lib Api 真源），格式 { value: label }
      apiPlatforms: {},
      adjustQuotaType: null,
      adjustQuotaValue: 0,
      adjustQuotaModalInstance: null,
      agencyFeatures: [],
      featuresLoading: false,
      featureModalAgency: null,
      featureSettingsModalInstance: null,
      apiTokenModalAgency: null,
      apiTokenModalInstance: null,
      apiTokens: [],
      apiTokenName: null,
      apiTokenPlainText: null,
      apiTokenLoading: false,
    };
  },
  computed: {
    ...mapState(["token", "userInfo", "isSystemManage", "language"]),
    fields() {
      return [
        {
          key: "name",
          label: i18n.t("__agencyName"),
          class: "align-middle",
          sortable: true,
        },
        {
          key: "codename",
          label: i18n.t("__agencyCodename"),
          class: "align-middle",
          sortable: true,
        },
        {
          key: this.isSystemManage ? "manager_id" : null,
          label: i18n.t("__agentName") + " / " + i18n.t("__account"),
          class: "align-middle",
          sortable: true,
        },
        {
          key: "locale",
          label: i18n.t("__language"),
          class: "align-middle text-center",
          sortable: true,
        },
        {
          key: "timezone",
          label: i18n.t("__timezone"),
          class: "align-middle text-center",
          sortable: true,
        },
        {
          key: "api",
          label: i18n.t("__apiPlatform"),
          class: "align-middle text-center",
          sortable: true,
        },
        {
          key: "users_count",
          label: i18n.t("__usersCount"),
          class: "align-middle text-center",
          sortable: true,
        },
        {
          key: "devices_count",
          label: i18n.t("__deviceCount"),
          class: "align-middle text-center",
          sortable: true,
        },
        {
          key: "status",
          label: i18n.t("__status"),
          class: "align-middle text-center",
          sortable: false,
        },
        {
          key: "status",
          label: i18n.t("__status"),
          class: "align-middle text-center",
          sortable: false,
        },
        {
          key: "active",
          label: i18n.t("__active"),
          tdClass: "align-middle",
          class: "align-middle",
          sortable: false,
        },
      ];
    },
    items() {
      const vm = this;
      let agencyFilter = vm.agency;

      if (vm.searchAgentCode) {
        agencyFilter = agencyFilter.filter((item) => {
          return item.codename.toLowerCase().includes(vm.searchAgentCode.toLowerCase());
        });
      }

      if (vm.searchAgent) {
        agencyFilter = agencyFilter.filter(
          (item) => vm.searchAgent === item.manager_id
        );
      }

      if (vm.search) {
        agencyFilter = agencyFilter.filter((item) => {
          return item.name.toLowerCase().includes(vm.search.toLowerCase());
        });
      }

      return agencyFilter;
    },
    timezones() {
      const timezones = [];
      moment.tz.names().forEach(function (timezone) {
        timezones.push({
          name: timezone,
          utc: moment.tz(timezone).format("Z"),
        });
      });
      return timezones;
    },
  },
  watch: {
    items(data) {
      const vm = this;
      if (data) {
        vm.initBootstrapTooltip();
        vm.totalRows = data.length;
        vm.currentPage = 1;
      }
    },
    modalData: {
      handler: function () {
        this.validate = null;
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["Loading", "Loaded", "AlertsInfo", "Alerted"]),
    getAgent() {
      const vm = this;
      agent.get("", vm.token).then((res) => {
        if (res.status <= 201 && res.data.status === "success") {
          vm.agents = res.data.data;
        }
      });
    },
    getApiPlatforms() {
      const vm = this;
      agency
        .getApiPlatforms(vm.token)
        .then((res) => {
          if (res.status <= 201 && res.data.status === "success") {
            const map = {};
            res.data.data.forEach((item) => {
              map[item.value] = item.label;
            });
            vm.apiPlatforms = map;
          } else {
            console.error("Failed to load api platforms:", res.data.errMsg);
          }
        })
        .catch((err) => {
          // 載入失敗：保持空物件（下拉為空但不噴錯）
          console.error("Failed to load api platforms:", err);
        });
    },
    getAgency() {
      const vm = this;
      vm.Loading();
      agency
        .get("", vm.token)
        .then((res) => {
          if (res.status <= 201 && res.data.status === "success") {
            vm.agency = res.data.data;
          } else {
            vm.AlertsInfo({
              state: "error",
              title: i18n.t("__error"),
              info: res.data.errMsg.toString(),
            });
            vm.Alerted();
          }
          vm.Loaded();
        })
        .catch((err) => {
          vm.AlertsInfo({
            state: "error",
            title: i18n.t("__error"),
            info: err,
          });
          vm.Alerted();
          vm.Loaded();
        });
    },
    searchAgency() {
      this.filter = this.search;
    },
    searchAgencyByName () {
      this.filter = this.searchAgentCode;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearSearch() {
      this.filter = null;
      this.search = null;
      this.searchAgentCode = null;
    },
    initBootstrapTooltip() {
      this.$nextTick(function () {
        this.bootstrap_tooltip = [].slice
          .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          .map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
          });
        document
          .querySelectorAll('[data-bs-toggle="tooltip"]')
          .forEach((ele) => {
            ele.addEventListener("shown.bs.tooltip", function () {
              setTimeout(() => {
                Tooltip.getInstance(ele).hide();
              }, 600);
            });
          });
      });
    },
    hideTooltip() {
      if (this.bootstrap_tooltip && this.bootstrap_tooltip.length) {
        this.bootstrap_tooltip.forEach((tooltip) => {
          tooltip.hide();
        });
      }
    },
    showModal(id) {
      const vm = this;
      vm.editModalId = id;
      vm.agencyFeatures = [];
      if (id) {
        vm.isEdit = true;
        vm.items.forEach((item) => {
          if (item.id === id) {
            vm.modalData.name = item.name;
            vm.modalData.codename = item.codename;
            vm.modalData.locale = item.locale;
            vm.modalData.timezone = item.timezone;
            vm.modalData.api = item.api;
            vm.modalData.service_type = item.service_type || "standard";
            vm.modalData.pdca_monthly_quota = (item.pdca_monthly_quota !== null && item.pdca_monthly_quota !== undefined) ? item.pdca_monthly_quota : 5;
            vm.modalData.case_report_monthly_quota = (item.case_report_monthly_quota !== null && item.case_report_monthly_quota !== undefined) ? item.case_report_monthly_quota : 5;
            vm.modalData.pdca_used_this_month = (item.pdca_used_this_month !== null && item.pdca_used_this_month !== undefined) ? item.pdca_used_this_month : 0;
            vm.modalData.case_report_used_this_month = (item.case_report_used_this_month !== null && item.case_report_used_this_month !== undefined) ? item.case_report_used_this_month : 0;
            vm.modalData.quota_reset_at = item.quota_reset_at || null;
            vm.modalData.disconnect_threshold_hours = (item.disconnect_threshold_hours !== null && item.disconnect_threshold_hours !== undefined) ? item.disconnect_threshold_hours : 3;
          }
        });
      } else {
        vm.isEdit = false;
        vm.modalData.name = null;
        vm.modalData.codename = null;
        vm.modalData.locale = null;
        vm.modalData.timezone = null;
        vm.modalData.api = null;
        vm.modalData.service_type = "standard";
        vm.modalData.pdca_monthly_quota = 5;
        vm.modalData.case_report_monthly_quota = 5;
        vm.modalData.pdca_used_this_month = 0;
        vm.modalData.case_report_used_this_month = 0;
        vm.modalData.quota_reset_at = null;
        vm.modalData.disconnect_threshold_hours = 3;
      }
      vm.bootstrap_modal = new Modal(vm.$refs.editModal);
      vm.$nextTick(function () {
        vm.bootstrap_modal.show();
      });
    },
    submitForm() {
      const vm = this;
      vm.Loading();
      if (vm.editModalId) {
        agency
          .update(
            vm.editModalId,
            {
              name: vm.modalData.name,
              codename: vm.modalData.codename,
              locale: vm.modalData.locale,
              timezone: vm.modalData.timezone,
              api: vm.modalData.api,
              service_type: vm.modalData.service_type,
              pdca_monthly_quota: vm.modalData.pdca_monthly_quota,
              case_report_monthly_quota: vm.modalData.case_report_monthly_quota,
              disconnect_threshold_hours: vm.modalData.disconnect_threshold_hours,
            },
            vm.token
          )
          .then((res) => {
            if (res.status <= 201 && res.data.status === "success") {
              vm.getAgency();
              vm.AlertsInfo({
                state: "success",
                title: i18n.t("__success"),
                info: i18n.t("__editSuccess"),
              });
              vm.Alerted();
              vm.bootstrap_modal.hide();
            } else {
              vm.AlertsInfo({
                state: "error",
                title: i18n.t("__error"),
                info: res.data.errMsg.toString(),
              });
              vm.Alerted();
              vm.validate = res.data.validate;
            }
            vm.Loaded();
          });
      } else {
        agency
          .create(
            {
              name: vm.modalData.name,
              codename: vm.modalData.codename,
              locale: vm.modalData.locale,
              timezone: vm.modalData.timezone,
              api: vm.modalData.api,
              service_type: vm.modalData.service_type,
            },
            vm.token
          )
          .then((res) => {
            if (res.status <= 201 && res.data.status === "success") {
              vm.getAgency();
              vm.AlertsInfo({
                state: "success",
                title: i18n.t("__success"),
                info: i18n.t("__createSuccess"),
              });
              vm.Alerted();
              vm.bootstrap_modal.hide();
            } else {
              vm.AlertsInfo({
                state: "error",
                title: i18n.t("__error"),
                info: res.data.errMsg.toString(),
              });
              vm.Alerted();
              vm.validate = res.data.validate;
            }
            vm.Loaded();
          });
      }
    },
    changeStatusAlert(id) {
      const vm = this;
      vm.editModalId = id;
      vm.items.forEach((item) => {
        if (item.id === id) {
          vm.modalData.name = item.name;
          vm.modalData.status = !item.status;
        }
      });
      vm.bootstrap_modal = new Modal(vm.$refs.changeStatusModal);
      vm.bootstrap_modal.show();
      vm.$refs.changeStatusModal.addEventListener("hidden.bs.modal", () => {
        vm.getAgency();
      });
    },
    changeStatus() {
      const vm = this;
      vm.Loading();
      agency
        .changeStatus(
          vm.editModalId,
          {
            status: vm.modalData.status,
          },
          vm.token
        )
        .then((res) => {
          if (res.status <= 201 && res.data.status === "success") {
            vm.AlertsInfo({
              state: "success",
              title: i18n.t("__success"),
              info: i18n.t("__changeStatus") + i18n.t("__success"),
            });
          } else {
            vm.AlertsInfo({
              state: "error",
              title: i18n.t("__error"),
              info: res.data.errMsg.toString(),
            });
          }
          vm.Alerted();
          vm.bootstrap_modal.hide();
          vm.Loaded();
        });
    },
    getAgentName() {
      this.items.forEach((item, index) => {
        this.agents.forEach((agent) => {
          if (agent.id === item.id) {
            this.$set(this.items[index], "agent", agent);
          }
        });
      });
    },
    deleteAgencyAlert(id) {
      const vm = this;
      vm.editModalId = id;
      vm.items.forEach((item) => {
        if (item.id === id) {
          vm.modalData.name = item.name;
        }
      });
      vm.bootstrap_modal = new Modal(vm.$refs.deleteModal);
      vm.bootstrap_modal.show();
      vm.$refs.changeStatusModal.addEventListener("hidden.bs.modal", () => {
        vm.getAgency();
      });
    },
    deleteAgency() {
      const vm = this;
      agency.delete(vm.editModalId, vm.token).then((res) => {
        if (res.status <= 201 && res.data.status === "success") {
          vm.AlertsInfo({
            state: "success",
            title: i18n.t("__success"),
            info: i18n.t("__deleteAgency") + i18n.t("__success"),
          });
          vm.getAgency();
        } else {
          vm.AlertsInfo({
            state: "error",
            title: i18n.t("__error"),
            info: res.data.errMsg.toString(),
          });
        }
        vm.Alerted();
        vm.Loaded();
        vm.bootstrap_modal.hide();
      });
    },
    impersonate(agencyId) {
      const vm = this;
      vm.Loading();
      agency.impersonate(agencyId, vm.token).then((res) => {
        if (res.status <= 201 && res.data.status === "success") {
          window.open(res.data.data.url, "_blank");
        } else {
          vm.AlertsInfo({
            state: "error",
            title: i18n.t("__error"),
            info: res.data.errMsg || i18n.t("__failed"),
          });
          vm.Alerted();
        }
        vm.Loaded();
      }).catch(() => {
        vm.Loaded();
      });
    },
    showAdjustQuotaModal(type) {
      const vm = this;
      vm.adjustQuotaType = type;
      vm.adjustQuotaValue = type === 'pdca'
        ? vm.modalData.pdca_used_this_month || 0
        : vm.modalData.case_report_used_this_month || 0;

      vm.adjustQuotaModalInstance = new Modal(vm.$refs.adjustQuotaModal);

      // 監聽 Modal 顯示事件，動態調整子 Modal 的 backdrop z-index
      vm.$refs.adjustQuotaModal.addEventListener('shown.bs.modal', () => {
        const backdrops = document.querySelectorAll('.modal-backdrop.show');
        if (backdrops.length >= 2) {
          backdrops[backdrops.length - 1].style.zIndex = '1056';
        }
      }, { once: true });

      vm.adjustQuotaModalInstance.show();
    },
    async confirmAdjustQuota() {
      const vm = this;

      if (!confirm(vm.$t('__confirmAdjustQuota'))) {
        return;
      }

      vm.Loading();
      try {
        const res = await agency.adjustQuota(
          vm.editModalId,
          {
            type: vm.adjustQuotaType,
            used: vm.adjustQuotaValue,
          },
          vm.token
        );

        if (res.status <= 201 && res.data.status === 'success') {
          vm.AlertsInfo({
            state: 'success',
            title: i18n.t('__success'),
            info: vm.$t('__adjustQuotaSuccess'),
          });
          vm.Alerted();
          vm.adjustQuotaModalInstance.hide();

          vm.getAgency();

          if (vm.adjustQuotaType === 'pdca') {
            vm.modalData.pdca_used_this_month = vm.adjustQuotaValue;
          } else {
            vm.modalData.case_report_used_this_month = vm.adjustQuotaValue;
          }
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errMsg || vm.$t('__adjustQuotaFailed'),
          });
          vm.Alerted();
        }
      } catch (error) {
        const errorMsg = (error.response && error.response.data && error.response.data.errMsg) || error.toString()
        vm.AlertsInfo({
          state: 'error',
          title: i18n.t('__error'),
          info: errorMsg,
        });
        vm.Alerted();
      }
      vm.Loaded();
    },
    showFeatureModal(agencyItem) {
      const vm = this;
      vm.featureModalAgency = agencyItem;
      vm.agencyFeatures = [];
      vm.getAgencyFeatures(agencyItem.id);
      vm.featureSettingsModalInstance = new Modal(vm.$refs.featureSettingsModal);
      vm.featureSettingsModalInstance.show();
    },
    async getAgencyFeatures(agencyId) {
      const vm = this;
      vm.featuresLoading = true;
      try {
        const res = await agency.getFeatures(agencyId, vm.token);
        if (res.status <= 201 && res.data.status === 'success') {
          vm.agencyFeatures = res.data.data || [];
        }
      } catch (error) {
        console.error('Failed to load agency features:', error);
      }
      vm.featuresLoading = false;
    },
    async getAllFeatures() {
      const vm = this;
      vm.featuresLoading = true;
      try {
        const res = await agency.getAllFeatures(vm.token);
        if (res.status <= 201 && res.data.status === 'success') {
          vm.agencyFeatures = res.data.data || [];
        }
      } catch (error) {
        console.error('Failed to load all features:', error);
      }
      vm.featuresLoading = false;
    },
    async saveAgencyFeatures() {
      const vm = this;
      if (!vm.featureModalAgency) return;

      const enabledFeatures = vm.agencyFeatures
        .filter(f => f.enabled)
        .map(f => f.code);

      vm.Loading();
      try {
        const res = await agency.updateFeatures(
          vm.featureModalAgency.id,
          { features: enabledFeatures },
          vm.token
        );
        if (res.status <= 201 && res.data.status === 'success') {
          vm.AlertsInfo({
            state: 'success',
            title: i18n.t('__success'),
            info: i18n.t('__featureSettingSaved'),
          });
          vm.Alerted();
          if (vm.featureSettingsModalInstance) {
            vm.featureSettingsModalInstance.hide();
          }
        } else {
          vm.AlertsInfo({
            state: 'error',
            title: i18n.t('__error'),
            info: res.data.errMsg || i18n.t('__failed'),
          });
          vm.Alerted();
        }
      } catch (error) {
        vm.AlertsInfo({
          state: 'error',
          title: i18n.t('__error'),
          info: error.toString(),
        });
        vm.Alerted();
      }
      vm.Loaded();
    },
    showApiTokenModal(agencyItem) {
      const vm = this;
      vm.apiTokenModalAgency = agencyItem;
      // 每次開啟都先清空，避免上一次產生的明文鑰匙殘留
      vm.resetApiTokenState();
      vm.getApiTokens(agencyItem.id);
      vm.apiTokenModalInstance = new Modal(vm.$refs.apiTokenModal);
      vm.$refs.apiTokenModal.addEventListener(
        "hidden.bs.modal",
        () => {
          vm.resetApiTokenState();
        },
        { once: true }
      );
      vm.apiTokenModalInstance.show();
    },
    resetApiTokenState() {
      this.apiTokens = [];
      this.apiTokenName = null;
      this.apiTokenPlainText = null;
    },
    /**
     * API 鑰匙操作失敗的統一提示
     * @param {string|null} info 後端 errMsg 或例外訊息，取不到時顯示通用失敗訊息
     */
    apiTokenFailed(info) {
      const vm = this;
      vm.AlertsInfo({
        state: "error",
        title: i18n.t("__error"),
        info: info ? info.toString() : i18n.t("__apiTokenActionFailed"),
      });
      vm.Alerted();
    },
    async getApiTokens(agencyId) {
      const vm = this;
      vm.apiTokenLoading = true;
      try {
        const res = await agency.getApiTokens(agencyId, vm.token);
        if (res.status <= 201 && res.data.status === "success") {
          vm.apiTokens = res.data.data || [];
        } else {
          vm.apiTokens = [];
          vm.apiTokenFailed(res.data && res.data.errMsg);
        }
      } catch (error) {
        vm.apiTokens = [];
        vm.apiTokenFailed(error);
      }
      vm.apiTokenLoading = false;
    },
    async createApiToken() {
      const vm = this;
      if (!vm.apiTokenModalAgency) return;
      const name = vm.apiTokenName ? vm.apiTokenName.trim() : "";
      vm.apiTokenLoading = true;
      let created = false;
      try {
        const res = await agency.createApiToken(
          vm.apiTokenModalAgency.id,
          name ? { name: name } : {},
          vm.token
        );
        if (res.status <= 201 && res.data.status === "success") {
          vm.apiTokenPlainText = res.data.data.plain_text_token;
          vm.apiTokenName = null;
          created = true;
          vm.AlertsInfo({
            state: "success",
            title: i18n.t("__success"),
            info: i18n.t("__apiTokenGenerateSuccess"),
          });
          vm.Alerted();
        } else {
          vm.apiTokenFailed(res.data && res.data.errMsg);
        }
      } catch (error) {
        vm.apiTokenFailed(error);
      }
      vm.apiTokenLoading = false;
      if (created) {
        vm.getApiTokens(vm.apiTokenModalAgency.id);
      }
    },
    async revokeApiToken(item) {
      const vm = this;
      if (!vm.apiTokenModalAgency) return;
      if (!confirm(i18n.t("__apiTokenRevokeConfirm", { name: item.name }))) {
        return;
      }
      vm.apiTokenLoading = true;
      let revoked = false;
      try {
        const res = await agency.revokeApiToken(
          vm.apiTokenModalAgency.id,
          item.id,
          vm.token
        );
        if (res.status <= 201 && res.data.status === "success") {
          revoked = true;
          vm.AlertsInfo({
            state: "success",
            title: i18n.t("__success"),
            info: i18n.t("__apiTokenRevokeSuccess"),
          });
          vm.Alerted();
        } else {
          vm.apiTokenFailed(res.data && res.data.errMsg);
        }
      } catch (error) {
        vm.apiTokenFailed(error);
      }
      vm.apiTokenLoading = false;
      if (revoked) {
        vm.getApiTokens(vm.apiTokenModalAgency.id);
      }
    },
    copyApiToken() {
      const vm = this;
      if (!vm.apiTokenPlainText) return;
      if (!navigator.clipboard) {
        vm.apiTokenFailed(i18n.t("__apiTokenCopyFailed"));
        return;
      }
      navigator.clipboard
        .writeText(vm.apiTokenPlainText)
        .then(() => {
          vm.AlertsInfo({
            state: "success",
            title: i18n.t("__success"),
            info: i18n.t("__apiTokenCopySuccess"),
          });
          vm.Alerted();
        })
        .catch(() => {
          vm.apiTokenFailed(i18n.t("__apiTokenCopyFailed"));
        });
    },
  },
  created() {
    this.getAgency();
    this.getApiPlatforms();
    if (this.isSystemManage) {
      this.getAgent();
    }
  },
  mounted() {
    this.$watch(
      (vm) => [vm.agents, vm.items],
      (val) => {
        if (this.agents && this.items) this.getAgentName();
      },
      {
        immediate: true,
        deep: true,
      }
    );
  },
};
</script>

<style lang="scss">
/* Modal 層疊樣式 */
::v-deep .modal-backdrop {
  z-index: 1050;
}

.modal {
  z-index: 1055;
}

#adjustQuotaModal {
  z-index: 1061 !important;
}
</style>
